import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, salon }) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 1000)); // Simulate API call
      onConfirm(salon);
      onClose();
    } catch (error) {
      console.error('Error deleting salon:', error);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen || !salon) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-modal z-modal flex items-center justify-center p-4">
      <div className="bg-card border border-border rounded-lg w-full max-w-md animate-scale-in">
        {/* Header */}
        <div className="flex items-center gap-3 p-6 border-b border-border">
          <div className="w-12 h-12 bg-error/10 rounded-full flex items-center justify-center">
            <Icon name="AlertTriangle" size={24} className="text-error" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-foreground">حذف سالن</h2>
            <p className="text-sm text-muted-foreground">این عمل قابل بازگشت نیست</p>
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          <p className="text-foreground mb-4">
            آیا از حذف سالن <span className="font-semibold">"{salon?.name}"</span> اطمینان دارید؟
          </p>
          
          <div className="bg-error/5 border border-error/20 rounded-lg p-4 mb-4">
            <div className="flex items-start gap-3">
              <Icon name="Info" size={16} className="text-error mt-0.5" />
              <div className="text-sm text-error">
                <p className="font-medium mb-1">هشدار:</p>
                <ul className="space-y-1 text-xs">
                  <li>• تمام اطلاعات کارمندان این سالن حذف خواهد شد</li>
                  <li>• تمام خدمات و نوبت‌های ثبت شده پاک خواهد شد</li>
                  <li>• این عمل قابل بازگشت نیست</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="bg-muted rounded-lg p-3">
            <div className="flex items-center gap-2 text-sm text-muted-foreground mb-2">
              <Icon name="MapPin" size={14} />
              <span>{salon?.address}</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Icon name="Users" size={14} />
              <span>{salon?.employeeCount} کارمند</span>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex gap-3 p-6 border-t border-border">
          <Button
            variant="outline"
            onClick={onClose}
            className="flex-1"
            disabled={loading}
          >
            انصراف
          </Button>
          <Button
            variant="destructive"
            onClick={handleConfirm}
            loading={loading}
            className="flex-1"
            iconName="Trash2"
            iconPosition="right"
          >
            حذف سالن
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;